import { Stack, Typography, Box, Button } from '@mui/material';
import React from 'react';
import cx from 'classnames';
import { ReactComponent as RocketLaunchIcon } from 'new/components/icons/fi-rr-rocket-launch.svg';
import styles from './PipelinesEmptyListGuide.module.scss';

interface GuideCTAProps {
  onCsvUploadClick: () => void;
}

const GuideCTA: React.FC<GuideCTAProps> = ({ onCsvUploadClick }) => {
  return (
    <Box className={cx(styles.ctaCard, styles.card)}>
      <Stack gap="4px" direction="column">
        <div className={styles.ctaTitle}>
          <RocketLaunchIcon />
          <Typography variant="h3">New to data integration?</Typography>
        </div>
        <div className={styles.ctaDescription}>
          <Typography variant="bodySmall">
            Start with CSV upload for instant results, then explore API connections.
          </Typography>
        </div>
      </Stack>
      <Button
        variant="outlined"
        size="small"
        className={styles.ctaButton}
        onClick={onCsvUploadClick}
      >
        Try CSV Upload
      </Button>
    </Box>
  );
};

export default GuideCTA;
